import { render } from "./ThirdStep.vue?vue&type=template&id=818f223e"
import script from "./ThirdStep.vue?vue&type=script&lang=js"
export * from "./ThirdStep.vue?vue&type=script&lang=js"

import "./ThirdStep.vue?vue&type=style&index=0&id=818f223e&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__